import { getClientById } from "api/customers";
import { GET_CLIENT_BY_ID } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

export const useGetClientById = (clientId) => {
  return useQuery([GET_CLIENT_BY_ID, clientId], () => getClientById(clientId), {
    enabled: !!clientId,
  });
};
